export default __webpack_public_path__ + "static/media/news-3.938b135c.jpg";